export const basicLicenseNrn = 'nrn:license-tier:ncloud:1fe20454-2f31-4453-ad84-eb68638289af';
export const constructionAdministrationNrn = 'nrn:license-tier:ncloud:3e030c3e-20fb-4c15-91a2-abde2a0b0b77';
